import React from 'react';
import { createPortal } from 'react-dom';
import { useGlobal } from '../../contexts/GlobalContext';

const icons = {
  success: { path: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z', color: 'text-teal' },
  error:   { path: 'M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z', color: 'text-danger' },
  warning: { path: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z', color: 'text-gold' },
  info:    { path: 'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z', color: 'text-accent' },
};

function ToastItem({ toast, onDismiss }) {
  const icon = icons[toast.type] ?? icons.info;
  return (
    <div className="flex items-start gap-3 card p-4 shadow-xl min-w-[300px] max-w-sm animate-slide-in">
      <svg className={`w-5 h-5 mt-0.5 flex-shrink-0 ${icon.color}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={icon.path} />
      </svg>
      <div className="flex-1 min-w-0">
        {toast.title   && <p className="text-sm font-medium text-text-main">{toast.title}</p>}
        {toast.message && <p className="text-xs text-text-muted mt-0.5">{toast.message}</p>}
      </div>
      <button onClick={() => onDismiss(toast.id)} className="text-text-muted hover:text-text-main">
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}

export default function ToastContainer() {
  const { toasts, dismissToast } = useGlobal();
  if (!toasts.length) return null;
  return createPortal(
    <div className="fixed bottom-5 right-5 z-[100] flex flex-col gap-2">
      {toasts.map(t => <ToastItem key={t.id} toast={t} onDismiss={dismissToast} />)}
    </div>,
    document.body,
  );
}
